import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/roboto-mono/400.css";
import "@fontsource/roboto-mono/500.css";
import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { ErrorFallback } from "./components/ErrorFallback.tsx";
import "./index.css";
import { initSentry } from "./sentry.ts";

initSentry();

// In dev mode, run axe-core on every render and log a11y violations to the console.
// Tree-shaken out of production builds.
if (import.meta.env.DEV) {
  void import("@axe-core/react").then((axe) => axe.default(React, ReactDOM, 1000));
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- #root is the SPA mount element guaranteed by index.html; missing it means the HTML shell is broken and there's nothing to recover.
ReactDOM.createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={ErrorFallback} showDialog={false}>
    <App />
  </Sentry.ErrorBoundary>,
);
